import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { changeUserPassword, clearMessage } from '../../../redux/slices/customer/configurationSlice';
import '../../../global.css';

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { isLoading, successMessage, errorMessage } = useSelector((state) => state.configuration);
  const [formData, setFormData] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [validationErrorMessage, setValidationErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  useEffect(() => {
    if (successMessage) {
    setFormData({
      current_password: '',
      new_password: '',
      confirm_password: ''
    });
    }
  }, [successMessage]);

   useEffect(() => {
    return () => {
      dispatch({ type: 'configuration/resetMessages' });
    };
  }, [dispatch]);

  useEffect(() => {
      dispatch(clearMessage());
  }, []);   

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(clearMessage());
    setValidationErrorMessage('');
    const { current_password, new_password, confirm_password } = formData;

    // Validate password fields
    if (!current_password || !new_password || !confirm_password) {
      setValidationErrorMessage('All fields are required.');
      return;
    }

    if (new_password !== confirm_password) {
      setValidationErrorMessage('New password and confirm password must match.');
      return;
    }
    setValidationErrorMessage('');
    dispatch(changeUserPassword(formData));
  };

  return (
    <Layout>
      <main className="main" style={{ overflow: 'unset' }}>
        <div className="card-entries mt-3">
          <header className="main-head flex justify-between align-center">
            <h1 className="greet-user-text">Change Password</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </header>

          <div className="main-content flex justify-between flex-col-rev-mob">
            <div style={{ width: '100%' }}>
              <div className="meals-container meals-added" style={{ width: '100%' }}>
                <div className="card" style={{ width: '100%' }}>
                  <form onSubmit={handleSubmit}>
                    {validationErrorMessage && (
                      <div className="alert alert-danger" role="alert">
                        {validationErrorMessage}
                      </div>
                    )}
                    {successMessage && (
                      <div className="alert alert-success" role="alert">
                        {successMessage}
                      </div>
                    )}

                    {errorMessage && (
                      <div className="alert alert-danger" role="alert">
                        {errorMessage}
                      </div>
                    )}

                    <div className="form-group">
                      <label htmlFor="current_password">Current Password</label>
                      <input
                        type="password"
                        id="current_password"
                        name="current_password"
                        className="input form-control"
                        required
                        value={formData.current_password}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="new_password">New Password</label>
                      <input
                        type="password"
                        id="new_password"
                        name="new_password"
                        className="input form-control"
                        required
                        value={formData.new_password}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="confirm_password">Confirm Password</label>
                      <input
                        type="password"
                        id="confirm_password"
                        name="confirm_password"
                        className="input form-control"
                        required
                        value={formData.confirm_password}
                        onChange={handleChange}
                      />
                    </div>
                    <button type="submit" className="btn btn-create change-password w-100" disabled={isLoading}>
                      {isLoading ? 'Changing...' : 'Change Password'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default ChangePassword;